import React, { useState, useEffect } from 'react';
import './ContactVerification.css';
import ProfilePage from './ProfilePage';
import { AiOutlineClose } from 'react-icons/ai';
import Loader from '../GlobalLoader/Loader';
import Massage from '../MassagePopUp/Massage';
import api from "./../../axiosInstance"
import logger from "../../utils/logger";

function ContactVerification({ setIsContactVerificationOpen }) {
  const [isOTPPage, setIsOTPPage] = useState(false);
  const [otpCode, setOtpCode] = useState(['', '', '', '']);
  const [mobileNumber, setMobileNumber] = useState('');
  const [countryCode, setCountryCode] = useState('+91');
  const [isLoading, setIsLoading] = useState(false);
  const [loaderMessage, setLoaderMessage] = useState('');
  const [showPatientForm, setShowPatientForm] = useState(false);
  const [resendDisabled, setResendDisabled] = useState(false);
  const [timer, setTimer] = useState(45);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const sendOtp = async () => {
    try {
      const fullMobile = countryCode.replace("+", "") + mobileNumber;

      // 1. POST request
      // 2. First arg: URL (relative)
      // 3. Second arg: Body (null, because you had no body in the original fetch)
      // 4. Third arg: Config object (contains params)
      const response = await api.post('/auth/send-otp', null, {
        params: {
          mobile: fullMobile
        }
      });

      logger.debug("OTP Response:", response.data);
      return response.data;

    } catch (e) {
      // Handle error safely
      const errorMessage = e.response?.data?.message || e.message;
      logger.error(`OTP Send Error: ${errorMessage}`);
      throw e; // Re-throw if you need the component to handle the error too
    }
  };

  const verifyOtp = async (otp) => {
    try {
      const fullMobile = countryCode.replace("+", "") + mobileNumber;
      const response = await api.get(`/auth/verify-otp`,{
        params : {
          otp: otp,
          mobile: fullMobile
        }
      })
      return response.data
    } catch (e) {
      const errorMessage = e.response?.data?.message || e.message;
      logger.error(`OTP Send Error: ${errorMessage}`);
      throw e;
    }
    
  };


  const handleNumberSubmit = async (e) => {
    e.preventDefault();

    // Remove non-digit characters
    const cleanedMobile = mobileNumber.replace(/\D/g, '');
    const expectedLength = countryCode === '+91' ? 10 : 10; // You can extend this for more countries

    // Basic validation
    if (!cleanedMobile) {
      setErrorMessage('Please enter your mobile number.');
      return;
    }

    if (cleanedMobile.length !== expectedLength) {
      setErrorMessage(`Please enter a valid phone number with ${expectedLength} digits.`);
      return;
    }

    // Optional pattern check for India
    if (countryCode === '+91' && !/^[6-9]\d{9}$/.test(cleanedMobile)) {
      setErrorMessage('Please enter a valid Indian mobile number.');
      return;
    }

    setLoaderMessage('Sending OTP to your mobile number');
    setIsLoading(true);

    try {
      // const res = await sendOtp();
      const res = {type:'success'};
      if (res && res.type === 'success') {
        // setSuccessMessage("✅ OTP sent successfully.");
        setShowPatientForm(true);
        // setIsOTPPage(true);
      } else {
        logger.debug(res)
        setErrorMessage('Please try again.');
      }
    } catch (error) {
      logger.error('OTP Send Error:', error);
      // setErrorMessage('❌ Something went wrong while sending OTP.');
    } finally {
      setIsLoading(false);
    }
  };


  const handleOtpChange = (e, index) => {
    const value = e.target.value;

    // Only allow digits
    if (!/^\d?$/.test(value)) return;

    const updated = [...otpCode];
    updated[index] = value;
    setOtpCode(updated);

    if (value && index < 3) {
      document.getElementsByClassName("otp-box")[index + 1].focus();
    }

    if (!value && index > 0) {
      document.getElementsByClassName("otp-box")[index - 1].focus();
    }
  };


  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    const enteredOtp = otpCode.join("");

    if (enteredOtp.length !== 4) {
      setErrorMessage("Please enter a valid 4-digit OTP.");
      return;
    }

    setLoaderMessage("Verifying your OTP...");
    setIsLoading(true);

    try {
      // const res = await verifyOtp(enteredOtp);
      const res = {type:'success'}
      if (res.type === "success") {
        setSuccessMessage("✔ OTP verified successfully!");
        setShowPatientForm(true);
      } else {
        setErrorMessage(res?.message || "Invalid OTP, try again.");
        setOtpCode(["", "", "", ""]);
      }
    } catch (error) {
      setErrorMessage("Something went wrong during OTP verification.");
    } finally {
      setIsLoading(false);
    }
  };


  const handleResendOtp = async () => {
    setResendDisabled(true);
    setTimer(45);
    try {
      await sendOtp();
      setSuccessMessage("OTP resent successfully.");
    } catch {
      setErrorMessage("Could not resend OTP.");
    }
  };


  useEffect(() => {
    let interval;
    if (resendDisabled) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    if (timer === 0) {
      setResendDisabled(false);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [resendDisabled, timer]);

  const closeModal = () => {
    setIsContactVerificationOpen(false);
    setIsOTPPage(false);
  };

  const handleCloseAll = () => {
    closeModal();
  };

  const handleMobileChange = (e) => {
    setMobileNumber(e.target.value);
    if (errorMessage) setErrorMessage(null);
  };


  return (
    <div className='popup-overlay'>
      {isLoading && <Loader message={loaderMessage} />}
      {errorMessage && (<Massage message={errorMessage} clearError={() => setErrorMessage('')} type="error" />)}
      {successMessage && (<Massage message={successMessage} clearError={() => setSuccessMessage('')} type="success" />)}
      {!showPatientForm ? (
        <div className='contact-verification-popup-container'>
          {!isOTPPage ? (
            <>
              <div className='contact-verification-close-icon-container'>
                <AiOutlineClose className="contact-verification-close-icon" onClick={closeModal} />
              </div>
              <h2 className='popup-container-main-heading'>Enter Patient Mobile Number</h2>
              <form onSubmit={handleNumberSubmit}>
                <div className='input-group'>
                  <select
                    value={countryCode}
                    onChange={(e) => setCountryCode(e.target.value)}
                    className='country-code-dropdown'
                  >
                    <option value='+91'>+91 (IND)</option>
                    <option value='+1'>+1 (USA)</option>
                  </select>
                  <input
                    type='tel'
                    placeholder='Mobile Number'
                    value={mobileNumber}
                    onChange={handleMobileChange}
                    required
                    className='contact-mobile-input'
                  />
                </div>
                <button type='submit' className='submit-btn'>Submit</button>
              </form>
            </>
          ) : (
            <>
              <div className='contact-verification-close-icon-container'>
                <AiOutlineClose className="contact-verification-close-icon" onClick={() => setIsOTPPage(false)} />
              </div>
              <h2 className="popup-container-main-heading">Enter OTP</h2>
              <form onSubmit={handleOtpSubmit}>
                <div className='otp-group'>
                  {otpCode.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      value={digit}
                      onChange={(e) => handleOtpChange(e, index)}
                      maxLength={1}
                      required
                      className="otp-box"
                      onFocus={(e) => e.target.select()}
                    />
                  ))}
                </div>
                <div className='btn-container-otp'>
                  <button type='submit' className='submit-btn'>Verify OTP</button>
                  <button
                    type='button'
                    onClick={handleResendOtp}
                    className='submit-btn'
                    disabled={resendDisabled}
                  >
                    {resendDisabled ? `Re-send (${timer}s)` : 'Re-send'}
                  </button>
                </div>
              </form>
            </>
          )}
        </div>
      ) : (
        <ProfilePage onClose={handleCloseAll} countryCode={countryCode} mobileNumber={mobileNumber} />
      )}
    </div>
  );
}

export default ContactVerification;
